import { useEffect, useState } from 'react'

const useCarouselScroll = (ref, orientation) => {
  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    const isHorizontal = orientation === 'horizontal'
    const refCurrent = ref.current
    if (!refCurrent) return

    const onscroll = e => {
      setScroll(isHorizontal ? e.target.scrollLeft : e.target.scrollTop)
    }
    refCurrent.addEventListener('scroll', onscroll)
    return () => refCurrent && refCurrent.removeEventListener('scroll', onscroll)
  }, [ref, orientation])

  return { scroll }
}

export default useCarouselScroll
